import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppService } from 'src/app/utils/services/app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
    public registerForm: FormGroup;
    constructor(private renderer: Renderer2, private toastr: ToastrService, private appService: AppService) {}

    ngOnInit() {
        this.renderer.addClass(document.querySelector('app-root'), 'register-page');
        this.registerForm = new FormGroup({
            fullName: new FormControl(null, Validators.required),
            email: new FormControl(null, Validators.required),
            password: new FormControl(null, Validators.required),
            retypePassword: new FormControl(null, Validators.required),
        });
    }

    register() {
        if (this.registerForm.valid) {
            this.appService.register();
        } else {
            this.toastr.error('Hello world!', 'Toastr fun!');
        }
    }

    ngOnDestroy() {
        this.renderer.removeClass(document.querySelector('app-root'), 'register-page');
    }
}
